import { useState } from "react";
import { FollowWrapper } from "@/styles/product";
import { useParams } from 'next/navigation';
import { followApi, unFollowApi } from "@/apis/service";
import { callAfterLogin } from "@/lib/jdiClientUtils";
import { useRouter } from 'next/navigation'
import FollowIcon from "@/images/icon/favorite.svg"

type Props = {
    followState: boolean
}


export default function Follow({followState}: Props) {
    const { sku } = useParams<{sku: string}>()
    const router = useRouter()
    const [isFollowed, setIsFollowed] = useState<boolean>(followState)

    const onHandleFollow = async (e: React.MouseEvent<HTMLDivElement>)=> {
        e.stopPropagation()

        callAfterLogin(async ()=> {

            if(!isFollowed) {
                const res = await followApi({bizIds: sku})
                if(res?.success) {
                    setIsFollowed(true)
                }

            } else {
                const res = await unFollowApi({bizIds: sku})
                if(res?.success) {
                    setIsFollowed(false)
                }

            }

        })

    }

    return <FollowWrapper onClick={onHandleFollow} className={`${isFollowed ? 'active' : ''}`}>
        <FollowIcon/>
    </FollowWrapper>
}
